module.exports = __webpack_public_path__ + "static/Gotham-Light-3bf4d03b016eabb031f9b3606c1f1ab8.woff";